import { render, staticRenderFns } from "./createQuotation.vue?vue&type=template&id=b20554b6&scoped=true&"
import script from "./createQuotation.vue?vue&type=script&lang=js&"
export * from "./createQuotation.vue?vue&type=script&lang=js&"
import style0 from "./createQuotation.vue?vue&type=style&index=0&id=b20554b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20554b6",
  null
  
)

export default component.exports